module.exports = __webpack_public_path__ + "img/wechat.d3742838.jpg";